import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "uk-container" }
const _hoisted_2 = { class: "uk-margin-bottom" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-gap-2 tw-cursor-pointer" }
const _hoisted_4 = { class: "uk-text-small uk-table-middle uk-table uk-table-condensed uk-table-small uk-table-divide uk-table-striped uk-table-hover" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "tw-font-bold text-slate-900" }
const _hoisted_7 = {
  key: 0,
  class: "uk-label uk-label-success"
}
const _hoisted_8 = {
  key: 1,
  class: "uk-label uk-label-inactive"
}
const _hoisted_9 = { class: "uk-text-left" }
const _hoisted_10 = { class: "uk-flex uk-flex-nowrap" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: "createDriver_isOwnerOperator",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showActiveOnly) = $event)),
          class: "uk-checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.showActiveOnly]
        ]),
        _cache[1] || (_cache[1] = _createTextVNode(" Show active drivers only ", -1))
      ])
    ]),
    _createElementVNode("table", _hoisted_4, [
      _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", { class: "uk-text-left uk-text-normal" }, "Name"),
          _createElementVNode("th", { class: "uk-text-bold uk-text-left" }, "Type"),
          _createElementVNode("th", { class: "uk-text-left uk-text-bolder" }, "Phone #"),
          _createElementVNode("th", { class: "uk-text-left" }, "Status"),
          _createElementVNode("th", { class: "uk-text-left" }, "Truck #"),
          _createElementVNode("th", { class: "uk-table-shrink" }, "Actions")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDrivers, (driver) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: driver.id,
            onClick: ($event: any) => (_ctx.selectDriver(driver)),
            style: {"cursor":"pointer"}
          }, [
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(driver.fullName), 1)
            ]),
            _createElementVNode("td", null, _toDisplayString(driver.isOwnerOperator ? 'Owner Operator' : 'Company Driver'), 1),
            _createElementVNode("td", null, _toDisplayString(driver.phoneNumber), 1),
            _createElementVNode("td", null, [
              (driver.isActive)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Active"))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "Inactive"))
            ]),
            _createElementVNode("td", _hoisted_9, _toDisplayString((driver.truck && driver.truck.length > 0) ? driver.truck[0].truckNumber : '---'), 1),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "uk-icon-button uk-margin-small-right",
                  "uk-icon": "pencil",
                  "uk-tooltip": "Edit",
                  onClick: _withModifiers(($event: any) => (_ctx.selectDriver(driver)), ["stop"])
                }, null, 8, _hoisted_11),
                _createElementVNode("button", {
                  class: "uk-icon-button uk-text-danger",
                  "uk-icon": "trash",
                  "uk-tooltip": "Delete (Deactivate)",
                  onClick: _withModifiers(($event: any) => (_ctx.confirmDelete(driver)), ["stop"])
                }, null, 8, _hoisted_12)
              ])
            ])
          ], 8, _hoisted_5))
        }), 128)),
        (_ctx.filteredDrivers.length === 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("td", {
                colspan: "6",
                class: "uk-text-center uk-text-muted tw-py-4"
              }, " No drivers found. ", -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}